"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SYSTEM_HEALTH_STATUS_LABELS = exports.SYSTEM_HEALTH_COMPONENT_PRIORITY = exports.SYSTEM_HEALTH_COMPONENT_LABELS = void 0;
const enums_1 = require("../enums");
exports.SYSTEM_HEALTH_COMPONENT_LABELS = {
  [enums_1.SystemHealthComponentId.Backend]: 'Backend API',
  [enums_1.SystemHealthComponentId.Database]: 'PostgreSQL',
  [enums_1.SystemHealthComponentId.S3]: 'AWS S3',
  [enums_1.SystemHealthComponentId.LocalStorage]: 'Local storage',
  [enums_1.SystemHealthComponentId.SendGrid]: 'SendGrid',
  [enums_1.SystemHealthComponentId.Twilio]: 'Twilio',
  [enums_1.SystemHealthComponentId.OneSignal]: 'OneSignal',
  [enums_1.SystemHealthComponentId.GoogleVision]: 'Google Cloud Vision',
  [enums_1.SystemHealthComponentId.GoogleMaps]: 'Google Maps',
  [enums_1.SystemHealthComponentId.WebSocket]: 'WebSocket',
  [enums_1.SystemHealthComponentId.ScheduledJobs]: 'Scheduled jobs',
  [enums_1.SystemHealthComponentId.Square]: 'Square payments'
};
/** Lower number = higher priority for aggregate status. */
exports.SYSTEM_HEALTH_COMPONENT_PRIORITY = {
  [enums_1.SystemHealthComponentId.Backend]: 0,
  [enums_1.SystemHealthComponentId.Database]: 0,
  [enums_1.SystemHealthComponentId.S3]: 0,
  [enums_1.SystemHealthComponentId.LocalStorage]: 0,
  [enums_1.SystemHealthComponentId.SendGrid]: 1,
  [enums_1.SystemHealthComponentId.Twilio]: 1,
  [enums_1.SystemHealthComponentId.OneSignal]: 1,
  [enums_1.SystemHealthComponentId.ScheduledJobs]: 1,
  [enums_1.SystemHealthComponentId.Square]: 1,
  [enums_1.SystemHealthComponentId.GoogleVision]: 2,
  [enums_1.SystemHealthComponentId.GoogleMaps]: 2,
  [enums_1.SystemHealthComponentId.WebSocket]: 2
};
exports.SYSTEM_HEALTH_STATUS_LABELS = {
  healthy: 'Healthy',
  degraded: 'Degraded',
  unhealthy: 'Unhealthy',
  not_configured: 'Not configured'
};
//# sourceMappingURL=system-health.js.map